// extracted by mini-css-extract-plugin
module.exports = {"list-videos":"list-videos","listVideos":"list-videos"};